import { inject, Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { RouterLinkFactory } from '../router/router-link-factory';
import { TOKEN } from '../utils/constant';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  routerLinks = inject(RouterLinkFactory);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // const token = localStorage.getItem(TOKEN) ?? '';
    // if (token == '') {
    //   window.location.href = environment.LoginSSOROP;
    // } else {
    //   if (
    //     state.url === '/' ||
    //     state.url === '/reset-password' ||
    //     state.url === '/otp' ||
    //     state.url === '/forgot-password'
    //   ) {
    //     this.router.navigate(this.routerLinks.homepage());
    //   }
    // }
    // return true; // Allow access to protected routes

    const token = localStorage.getItem(TOKEN);

    if (token) {
      // If the user is authenticated and trying to access an auth route, redirect to dashboard
      if (
        state.url === '/' ||
        state.url === '/reset-password' ||
        state.url === '/otp' ||
        state.url === '/forgot-password'
      ) {
        this.router.navigate(this.routerLinks.homepage());
        return false; // Prevent access to auth routes
      }
      return true; // Allow access to protected routes
    } else {
      // If not authenticated and trying to access a protected route, redirect to login
      if (
        state.url !== '/' &&
        state.url !== '/reset-password' &&
        state.url !== '/otp' &&
        state.url !== '/forgot-password'
      ) {
        this.router.navigate(['/']);
      }
      return true; // Allow access to login/register routes
    }
  }
}
